import SupportV2OrdersListPage from 'pages/support-v2/support-v2-orders-list-page';

export default function SupportOrdersDetailPage() {
  return <SupportV2OrdersListPage />;
}
